// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ot-0";
export var buttonContainer = "_ot-3";
export var cancelButton = "_ot-4";
export var headerSection = "_ot-6";
export var headerTitle = "_ot-9";
export var messageSideLeft = "_ot-1";
export var messageSideRight = "_ot-2";
export var orderNumberContainer = "_ot-7";
export var orderNumberLabel = "_ot-8";
export var submitButton = "_ot-5";